const LANGUAGES = ['ENG', 'DEU', 'FRA', 'NLD'];

// COGNITO
const COGNITO_CONFIG = {
  aws_project_region: 'eu-central-1',
  aws_cognito_region: 'eu-central-1',
  aws_user_pools_id: 'eu-central-1_7EdiA1yQC',
  aws_user_pools_web_client_id: '52v9dgv49k6690mbegkpeb69d5',
};

// COGNITO
const ONELOGIN_CONFIG = {
  client_id: '6052b330-e6b2-0137-7903-024fbe80e01e37836',
};

// EXPORO API --- DEV
const DEV_CONFIG = {
  title: 'Development',
  BASE_API: {
    AUTH: 'https://exporo.onelogin.com/oidc/2',
    PAYMENT: 'http://localhost',
    USERS: 'https://backend.exporo.de/api/intern/admin/user',
    ONBOARDING_USERS: 'https://api.user.exporo.com/stage',
    REGISTRATION_USERS: 'https://u5qz1yzh07.execute-api.eu-central-1.amazonaws.com/dev',
    EMAIL: 'https://api.mail.exporo.de/dev',
    BAADER: 'https://baader.exporo.de/api/exporo',
    INVESTMENT_REPORTING_ENGINE: 'http://localhost:3000',
    FINANCIAL_PRODUCT: 'https://z2dyx2kmnk.execute-api.eu-central-1.amazonaws.com/prod',
    SECURITIES: 'https://baader.exporo.de/api/exporo/security',
    ORDERING: 'https://api.ordering.exporo.de/dev/v1',
    IDENT: 'https://dev.ident.exporo.de',
    IDENT_S3: 'https://vylwcjkzqk.execute-api.eu-central-1.amazonaws.com/dev',
    BRIDGE_SIGNING: 'http://exporo.localhost/api/intern/admin/bridge-signing',
    TRADING_PLATFORM: 'https://f4bf674a-ce4d-4ed6-a14b-b54e5e1c9da7.mock.pstmn.io',
    EMONEY: 'https://api.emoney.exporo.com/stage',
    STRATEGIES_SETTLEMENT: 'https://settlement.dev.strategies.exporo.com/master/',
    STRATEGIES: 'https://api.dev.strategies.exporo.com/master',
    CENTRAL_EVENTS_STORE: 'https://wuuzlj1s3j.execute-api.eu-central-1.amazonaws.com/dev',
    TOKEN_TRANSFERS: 'https://transfer.wallet.exporo.de/dev/',
    PAYOUT_AND_TAXES: 'https://dev.pat.exporo.com',
    PAYOUT_AND_TAXES_JEA: 'https://dev.pat.exporo.com/jea',
    PAYOUT_AND_TAXES_2: 'https://176e9992-06d9-40a8-8cfd-f9f8a514658c.mock.pstmn.io', // 'https://pat2-dev.exporo.com',
    UPVEST_WALLET: 'https://wallet.exporo.de/dev/v1/',
    VAULT: 'http://localhost:3000/master',
    VAULT_BASE: 'http://localhost:3000/master',
    MKI_ADMIN_BASE: 'https://api.dev-investment.exporo.de/admin',
    EIE_ADMIN_BASE: 'https://5zrpi945pl.execute-api.eu-central-1.amazonaws.com/prod/admin',
    EXPOSE_BASE: 'https://fa569782-ba0c-4d33-8cea-4a0d178d9028.mock.pstmn.io',
    SIGNING_DOCUMENT: 'https://api.signing-documents.exporo.com/dev',
  },
  COGNITO_CONFIG,
  ONELOGIN_CONFIG,
  LANGUAGES,
};

// EXPORO API --- STAGE

const STAGE_CONFIG = {
  title: 'Staging',
  BASE_API: {
    AUTH: 'https://exporo.onelogin.com/oidc/2',
    PAYMENT: 'https://payment.exporo.io',
    USERS: 'https://backend.exporo.de/api/intern/admin/user',
    EXPLORATION: 'https://stage.exploration.exporo.de',
    ONBOARDING_USERS: 'https://api.user.exporo.com/stage',
    REGISTRATION_USERS: 'https://q8fvnqf71j.execute-api.eu-central-1.amazonaws.com/stage',
    EMAIL: 'https://api.mail.exporo.de/dev',
    BAADER: 'https://baader.exporo.de/api/exporo',
    INVESTMENT_REPORTING_ENGINE: 'https://stage.ire.exporo.com',
    FINANCIAL_PRODUCT: 'https://financial-products-stage.exporo.de',
    SECURITIES: 'https://baader.exporo.de/api/exporo/security',
    ORDERING: 'https://api.ordering.exporo.de/dev/v1',
    IDENT: 'https://master.ident.exporo.de',
    IDENT_S3: 'https://vylwcjkzqk.execute-api.eu-central-1.amazonaws.com/dev',
    BRIDGE_SIGNING: 'http://exporo.localhost/api/intern/admin/bridge-signing',
    TRADING_PLATFORM: 'https://api.trade.exporo.com/stage',
    EMONEY: 'https://api.emoney.exporo.com/stage',
    STRATEGIES_SETTLEMENT: 'https://settlement.dev.strategies.exporo.com/master',
    STRATEGIES: 'https://api.dev.strategies.exporo.com/master',
    CENTRAL_EVENTS_STORE: 'https://k5vmdale7h.execute-api.eu-central-1.amazonaws.com/stage',
    TOKEN_TRANSFERS: 'https://transfer.wallet.exporo.de/dev/',
    PAYOUT_AND_TAXES: 'https://stage.pat.exporo.com',
    PAYOUT_AND_TAXES_JEA: 'https://stage.pat.exporo.com/jea',
    PAYOUT_AND_TAXES_2: 'https://pat2-stage.exporo.com',
    UPVEST_WALLET: 'https://wallet.exporo.de/dev/v1/',
    VAULT: 'https://api.vault.xporo.de/master',
    VAULT_BASE: 'https://api.vault.xporo.de',
    MKI_ADMIN_BASE: 'https://api.stage-investment.exporo.de/admin',
    EIE_ADMIN_BASE: 'https://om5xk2d3q6.execute-api.eu-central-1.amazonaws.com/prod/admin',
    EXPOSE_BASE: 'https://stage.expose-service.exporo.de',
    SIGNING_DOCUMENT: 'https://api.signing-documents.exporo.com/stage',
  },
  COGNITO_CONFIG,
  ONELOGIN_CONFIG,
  LANGUAGES,
};

// EXPORO API --- PROD//

const PROD_CONFIG = {
  title: 'Production',
  BASE_API: {
    AUTH: 'https://exporo.onelogin.com/oidc/2',
    PAYMENT: 'https://payment.exporo.com',
    USERS: 'https://backend.exporo.de/api/intern/admin/user',
    EXPLORATION: 'https://prod.exploration.exporo.de',
    ONBOARDING_USERS: 'https://api.user.exporo.com/prod',
    REGISTRATION_USERS: 'https://neqv9pvqwj.execute-api.eu-central-1.amazonaws.com/prod',
    EMAIL: 'https://api.mail.exporo.de/prod',
    BAADER: 'https://baader.exporo.de/api/exporo',
    INVESTMENT_REPORTING_ENGINE: 'https://api.ire.exporo.com',
    FINANCIAL_PRODUCT: 'https://financial-products.exporo.de',
    SECURITIES: 'https://baader.exporo.de/api/exporo/security',
    ORDERING: 'https://api.ordering.exporo.de/prod/v1',
    IDENT: 'https://ident.exporo.de',
    IDENT_S3: 'https://vylwcjkzqk.execute-api.eu-central-1.amazonaws.com/prod',
    BRIDGE_SIGNING: 'https://backend.exporo.de/api/intern/admin/bridge-signing',
    TRADING_PLATFORM: 'https://api.trade.exporo.com/prod',
    EMONEY: 'https://api.emoney.exporo.com/prod',
    STRATEGIES_SETTLEMENT: 'https://settlement.strategies.exporo.com',
    STRATEGIES: 'https://api.strategies.exporo.com',
    CENTRAL_EVENTS_STORE: 'https://04p0589y43.execute-api.eu-central-1.amazonaws.com/prod',
    TOKEN_TRANSFERS: 'https://transfer.wallet.exporo.de/api/',
    PAYOUT_AND_TAXES: 'https://api.pat.exporo.com',
    PAYOUT_AND_TAXES_JEA: 'https://api.pat.exporo.com/jea',
    PAYOUT_AND_TAXES_2: 'https://pat2-prod.exporo.com',
    UPVEST_WALLET: 'https://wallet.exporo.de/api/v1/',
    VAULT: 'https://api.vault.exporo.com',
    VAULT_BASE: 'https://api.vault.exporo.com',
    MKI_ADMIN_BASE: 'https://api.investment.exporo.de/admin',
    EIE_ADMIN_BASE: 'https://of4rzuraoa.execute-api.eu-central-1.amazonaws.com/prod/admin',
    EXPOSE_BASE: 'https://expose-service.exporo.de',
    SIGNING_DOCUMENT: 'https://api.signing-documents.exporo.com/prod',
  },
  COGNITO_CONFIG,
  ONELOGIN_CONFIG,
  LANGUAGES,
};

// EXPORT CONFIGURATION//

const apiEnv = {
  dev: DEV_CONFIG,
  stage: STAGE_CONFIG,
  prod: PROD_CONFIG,
};

export default apiEnv;



// WEBPACK FOOTER //
// ./src/enum/apiEnv.js